/**
 * The proved / stale / failed badge shared by criteria and their evidence rows.
 *
 * @module features/proofs/components/ItemStatusBadge
 */
import React from 'react';
import { StatusBadge } from '@chatsdet/ui';
import { sha7 } from '../evidenceKinds';
import type { ProofCriterion } from '../types';

export const ItemStatusBadge: React.FC<{ status: ProofCriterion['status'] }> = ({ status }) => {
  if (status.kind === 'proved') return <StatusBadge status="success" label="Proved" size="sm" />;
  if (status.kind === 'stale') {
    return <StatusBadge status="waiting" label={`Stale (proved at ${sha7(status.provedSha)})`} size="sm" />;
  }
  return <StatusBadge status="failed" label="Failed" size="sm" />;
};
